var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bell-a",
    d: "M16.5019352,8.30012907 C16.5019352,5.81479678 14.4871753,3.80003688 12.001843,3.80003688 C9.51651071,3.80003688 7.50175081,5.81479678 7.50175081,8.30012907 C7.50175081,11.20291 6.95990837,13.4605868 6.04182691,15.1437362 C5.97386788,15.2683278 5.90551336,15.3871304 5.83705715,15.5002766 L18.1666289,15.5002766 C18.0981726,15.3871304 18.0298181,15.2683278 17.9618591,15.1437362 C17.0437776,13.4605868 16.5019352,11.20291 16.5019352,8.30012907 Z M18.3019721,8.30012907 C18.3019721,10.909961 18.7726504,12.8711207 19.5421035,14.2817847 C19.7997395,14.7541173 20.070028,15.1235117 20.3334961,15.4016169 C20.475803,15.5518297 20.5716458,15.6316987 20.6012493,15.6514344 C21.342178,16.1453868 20.9924944,17.3003135 20.1020089,17.3003135 L3.90167705,17.3003135 C3.01119165,17.3003135 2.66150801,16.1453868 3.40243665,15.6514344 C3.43204023,15.6316987 3.52788298,15.5518297 3.6701899,15.4016169 C3.93365797,15.1235117 4.20394654,14.7541173 4.46158251,14.2817847 C5.23103562,12.8711207 5.70171393,10.909961 5.70171393,8.30012907 C5.70171393,4.82066386 8.52237779,2 12.001843,2 C15.4813082,2 18.3019721,4.82066386 18.3019721,8.30012907 Z M12.7803589,19.5487648 C13.0297729,19.1188024 13.5805163,18.9724389 14.0104788,19.2218528 C14.4404413,19.4712668 14.5868048,20.0220102 14.3373908,20.4519727 C13.854354,21.2846756 12.9645053,21.7972162 12.001843,21.7972162 C11.0391807,21.7972162 10.149332,21.2846756 9.66629515,20.4519727 C9.41688119,20.0220102 9.56324469,19.4712668 9.99320718,19.2218528 C10.4231697,18.9724389 10.9739131,19.1188024 11.2233271,19.5487648 C11.3843393,19.8263325 11.6809556,19.9971794 12.001843,19.9971794 C12.3227304,19.9971794 12.6193467,19.8263325 12.7803589,19.5487648 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bell-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bell-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#bell-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#bell-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b09b00a6a21cc42c53c142e7907f5d5f.svg";
export { ForwardRef as ReactComponent };